import styled from 'styled-components';
import IconButton from '../IconButton';
export var StyledCloseButton = styled(IconButton).withConfig({
  displayName: "CloseButtonstyles__StyledCloseButton",
  componentId: "sc-1b8vdzp-0"
})([""]);